import { render, staticRenderFns } from "./lecturerAlbum.vue?vue&type=template&id=021d5f9d&"
import script from "./lecturerAlbum.vue?vue&type=script&lang=js&"
export * from "./lecturerAlbum.vue?vue&type=script&lang=js&"
import style0 from "./lecturerAlbum.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports